export const getPeoplePathRedirect = (
  pathname: string,
  search = ''
): string | null => {
  if (!pathname.startsWith('/people') || !pathname.includes('//')) {
    return null;
  }

  let normalizedPath = pathname.replace(/\/{2,}/g, '/');

  if (normalizedPath === '/people/') {
    normalizedPath = '/people';
  }

  return `${normalizedPath}${search}`;
};
